import { IconButton, IconCopyLine, Text, Tooltip } from "@instructure/ui";
import { t } from "i18next";
import { useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import { Card } from "../Card";
import ProgressStepper from "../ProgressStepper";
import { CourseReviewContext } from "./CourseReview";
import ReflectionsAndActionsCard from "./Summary/ReflectionsAndActionsCard";
import ResultsChart from "./Summary/ResultsChart";
import { getCourseReviewSteps } from "./utils";

const CourseReviewSummary = () => {
  const location = useLocation();
  const review = location.state.review;

  const { draftData } = useContext(CourseReviewContext);
  const results = draftData.results.data;
  const presentationType = draftData.results.presentation_type;
  const masteryResults = draftData.results.mastery_results;
  const reflections = draftData.selectedReflections;
  const reflectionsSummary = draftData.reflectionsSummary;
  const actions = draftData.selectedActions;
  const actionsSummary = draftData.actionsSummary;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1.5rem",
        height: "100%",
      }}
    >
      {review.shareable_code ? (
        <BuildPublicPath code={review.shareable_code} />
      ) : (
        <ProgressStepper steps={getCourseReviewSteps(t)} currentStep={4} />
      )}
      <div
        style={{ overflowY: "auto", margin: "-0.75rem", padding: "0.75rem" }}
        tabIndex={0}
      >
        <ResultsChart
          results={results}
          presentationType={presentationType}
          masteryResults={masteryResults}
        />
        <ReflectionsAndActionsCard
          reflections={reflections}
          reflectionsSummary={reflectionsSummary}
          actions={actions}
          actionsSummary={actionsSummary}
        />
      </div>
    </div>
  );
};

export default CourseReviewSummary;

const BuildPublicPath = ({ code }) => {
  const [copyText, setCopyText] = useState(t("results.copyToClipboard"));
  const tenantID = window.location.hostname.split(".")[0];
  const stage = window.location.hostname.split("/")[0];
  const publicUrl = `${stage}/public/public-course-review/${tenantID}/${code}`;

  return (
    <Card style={{ height: "auto" }}>
      <Text>{t("courseReview.isPublic")} </Text>
      <Text id="share-url" weight="bold">
        {publicUrl}
      </Text>
      <Tooltip
        renderTip={copyText}
        on={["hover", "focus"]}
        onHideContent={() => setCopyText(t("results.copyToClipboard"))}
      >
        <IconButton
          color="primary"
          renderIcon={IconCopyLine}
          screenReaderLabel={t("results.copyToClipboard")}
          size="small"
          margin="0 0 0 x-small"
          withBorder={false}
          withBackground={false}
          onClick={() => {
            navigator.clipboard.writeText(publicUrl);
            setCopyText(t("results.copiedToClipboard"));
          }}
        />
      </Tooltip>
    </Card>
  );
};
